import { formatDate, money } from "@/lib/format";
import type { ExpiringItem } from "@/lib/metrics";

export default function ExpiringSection({ items }: { items: ExpiringItem[] }) {
  if (items.length === 0) return null;

  return (
    <div className="rounded-3xl border border-accent-200 bg-accent-50 p-4">
      <div className="flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-xl bg-accent-100 text-accent-800">
          <i className="ri-alarm-warning-line text-base" />
        </span>
        <p className="text-[14px] font-semibold text-accent-900">Productos próximos a vencer</p>
      </div>
      <div className="mt-3 space-y-2.5">
        {items.slice(0, 4).map(({ lot, remaining, days }) => (
          <div key={lot.id} className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate text-[13px] font-medium text-foreground-900">{lot.productName}</p>
              <p className="text-[11px] text-foreground-500">
                {remaining} und · vence {formatDate(lot.expirationDate || "")}
              </p>
            </div>
            <span
              className={`flex-none rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                days <= 0 ? "bg-red-500 text-white" : "bg-accent-500 text-white"
              }`}
            >
              {days <= 0 ? "Vencido" : `${days} días`}
            </span>
          </div>
        ))}
        {items.length > 4 ? (
          <p className="pt-1 text-[11px] text-accent-800">
            +{items.length - 4} más · valor en riesgo {money(
              items.reduce((s, i) => s + i.remaining * i.lot.unitCost, 0),
              items[0].lot.currency,
            )}
          </p>
        ) : null}
      </div>
    </div>
  );
}